import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import Notfound from "@components/Not-Found";
import moment from "moment";
import {
  adminBulkLocationUpdateStatus,
  clientGetLocation,
} from "@services/location.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
  createUploadReport,
  deleteComplianceReports,
  getComplianceReports,
  getSpecificComplianceReports,
  updateReport,
} from "@services/reports.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { useParams } from "react-router-dom";
import { Modal } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import SimpleReactValidator from "simple-react-validator";
import { formatText } from "@_common/format-text";
// import DatePicker from 'react-date-picker';
import DatePicker from "react-datepicker";
import { months } from "@_common/month";
import { years } from "@_common/year";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { convertCurrentDate } from "@_common/date-helpers";
import ReportsNotfoundPopup from "@components/Page-Not-Found/reports-not-found-popup";
import MoreReportSvgComponent from "../../../../../assets/svg-components/left-menu/more-report";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { sanitizeInput } from "@_common/dompurify";
import { deleteExports } from "@services/import.service";

interface IReportsVendorAuditUploadsProps {}

const ReportsVendorAuditUploads: React.FunctionComponent<
  IReportsVendorAuditUploadsProps
> = (props: any) => {
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [info, setInfo] = useState({});
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      report_type: "VENDOR_AUDIT_UPLOADS",
      // status: "active",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getComplianceReports(queryRequest);
      if (resp) {
        setInfo(getValue(resp, `data`, {}));
        setList(
          getValue(resp, `data.reports`, []).map((item: object) => ({
            ...item,
            created_at: getValue(item, `created_at`, "")
              ? convertCurrentDate(getValue(item, `created_at`, ""))
              : "",
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            report_type: formatText(getValue(item, `report_type`, "")),
            generated_by:
              getValue(resp, `data.user.first_name`, "") +
              " " +
              getValue(resp, `data.user.last_name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState: any = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.status = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/add-clientlist/profile/${id}`);
  };
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/location/detail/${getValue(obj, `original.id`, "")}`);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const handleRemoveRecord = async (deleteId: any) => {
    try {
      const idsArray = Array.isArray(deleteId) ? deleteId : [deleteId];
      let resp = await deleteExports({ ids: idsArray });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData();
      }
    } catch (error) {}
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Report Name",
        accessor: "report_name",
        width: 250,
        Cell: ({ row }: any) => {
          return (
            // <NavLink to={`/location/detail/${row.original.id}`}>
            <>{row.values.report_name}</>
            // </NavLink>
          );
        },
      },
      {
        Header: "Report Description",
        accessor: "report_description",
        width: 250,
      },
      {
        Header: "Report Type",
        accessor: "report_type",
        width: 150,
      },
      {
        Header: "Generated On",
        accessor: "created_at",
        width: 120,
      },
      {
        Header: "Download",
        width: 150,
        Cell: ({ row }: any) => {
          return (
            !row.original.is_verified && (
              <>
                <div className="table_download_container">
                  <button
                    className="resend-btn d-flex align-items-center ms-0"
                    onClick={(e) =>
                      handleDownloadOnClick(
                        getValue(row, `original.report_url`, ""),
                        getValue(row, `original.report_name`, "")
                      )
                    }
                    style={{
                      color: getValue(row, `original.report_url`, "")
                        ? "#1A73E8"
                        : "black",
                    }}
                    disabled={!getValue(row, `original.report_url`, "")}
                  >
                    {getValue(row, `original.report_url`, "") ? (
                      <img
                        src="/images/download.svg"
                        className="img-fluid d-block"
                      />
                    ) : (
                      <img
                        src="/images/clock.svg"
                        className="img-fluid d-block"
                        style={{
                          height: "18px",
                          width: "18px",
                          marginRight: "5px",
                        }}
                      />
                    )}
                    {getValue(row, `original.report_url`, "")
                      ? "Download"
                      : "Processing"}
                  </button>
                  {!getValue(row, `original.report_url`, "") &&
                    getValue(row, `original.status`, "") !== "Failed" && (
                      <img
                        src="/images/reload.svg"
                        className="img-fluid d-block"
                        style={{
                          height: "22px",
                          width: "22px",
                          marginLeft: "10px",
                        }}
                        onClick={() => getData()}
                      />
                    )}
                </div>

                {getValue(row, `original.queue_status`, "") !== "COMPLETED" ? (
                  <button
                    className="resend-btn d-flex align-items-center ms-0 mt-1"
                    onClick={(e) =>
                      handleRemoveRecord(getValue(row, `original.id`, ""))
                    }
                    style={{ color: "#d7242e" }}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src="/images/close-red.svg"
                        className="img-fluid d-block"
                      />
                      Remove
                    </div>
                  </button>
                ) : (
                  ""
                )}
              </>
            )
          );
        },
      },
    ],
    []
  );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkLocationUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await deleteComplianceReports({ ids: selectedIDs });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  const [scheduleLoading, setScheduleLoading] = useState(false);
  const handleStopSchedule = async () => {
    try {
      setScheduleLoading(true);
      let obj: any = {
        is_scheduled: false,
      };
      // Object.keys(obj).forEach((key) => {
      // 	if (!obj[key] || obj[key] === undefined) {
      // 		delete obj[key];
      // 	}
      // });
      let resp = await updateReport(mainParams.id, obj);
      if (resp) {
        setScheduleLoading(false);
        toast.success("Updated successfully");
        getData();
      } else {
        setScheduleLoading(false);
      }
    } catch (error) {
      setScheduleLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                             Report Add section                             */
  /* -------------------------------------------------------------------------- */

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [request, setRequest] = useState({
    report_type: "VENDOR_AUDIT_UPLOADS",
    from_date: null,
    to_date: null,
    report_name: "",
    report_description: "",
    month: [],
    year: [],
  });
  const handleRequest = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: value,
    });
  };

  const [isOpen, setIsOpen] = useState<any>(false);
  const handleAddFun = () => {
    handleModal();
  };
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    let dates = date ? date : new Date();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        setSubmitLoading(true);
        let obj = JSON.parse(JSON.stringify(request));

        // Extract month and year values from selected objects
        const selectedMonths = getValue(obj, `month`, []).map((item: any) =>
          parseInt(getValue(item, `value`, ""))
        );
        const selectedYears = getValue(obj, `year`, []).map((item: any) =>
          getValue(item, `value`, "")
        ); // Keep as string for year

        // Create cartesian product of months and years
        const dateRange: any[] = [];
        selectedMonths.forEach((month: number) => {
          selectedYears.forEach((year: string) => {
            dateRange.push({
              month: month,
              year: year,
            });
          });
        });

        let payload = {
          report_type: getValue(obj, `report_type`, ""),
          from_date: moment(getValue(obj, `from_date`, "")).format(
            "YYYY-MM-DD"
          ),
          to_date: moment(getValue(obj, `to_date`, "")).format("YYYY-MM-DD"),
          report_name: getValue(obj, `report_name`, ""),
          report_description: getValue(obj, `report_description`, ""),
          // month: parseInt(getValue(obj, `month`, "")), // commented for date_range
          // year: parseInt(getValue(obj, `year`, "")), // commented for date_range
          month: 8, // dummy value for date_range
          year: 2025, // dummy value for date_range
          date_range: dateRange,
          // month: params.date
          // 	? parseInt(params.date.split('-')[1])
          // 	: date
          // 		? parseInt(moment(date).format('MM'))
          // 		: parseInt(moment(dates).format('MM')),
          // year: params.date
          // 	? parseInt(params.date.split('-')[0])
          // 	: date
          // 		? parseInt(moment(date).format('YYYY'))
          // 		: parseInt(moment(dates).format('YYYY')),
        };
        let resp = await createUploadReport(payload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          getData();
          handleModal();
          setRequest({
            ...request,
            report_type: "VENDOR_AUDIT_UPLOADS",
            from_date: null,
            to_date: null,
            report_name: "",
            report_description: "",
            month: [],
            year: [],
          });
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Date section                                 */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);

  const handleDate = (date: any) => {
    // setFirstDay(date[0]);
    // setLastDay(date[1]);
    setRequest({
      ...request,
      from_date: date[0],
      to_date: date[1],
    });
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Month Section                              */
  /* -------------------------------------------------------------------------- */

  const [year, setYear] = React.useState<any>("2022");

  // const handleSubmitDate = () => {
  // 	let dates = moment(date).format('YYYY-MM-DD');
  // 	if (dates && dates !== 'Invalid date') {
  // 		let payload: any = {
  // 			date: dates,
  // 		};
  // 		// removing null values
  // 		Object.keys(payload).forEach((key) => {
  // 			if (!payload[key] || payload[key] === undefined) {
  // 				delete payload[key];
  // 			}
  // 		});
  // 		let queryRequest = QueryRequestHelper(payload);
  // 		navigate(`${window.location.pathname}?${queryRequest}`);
  // 	} else {
  // 		toast.error('Please select date');
  // 	}
  // };

  const handleNavigate = (bodyObj: object) => {
    navigate(
      `/audit/details/${getValue(bodyObj, `vendor_id`, "")}/${moment(
        date
      ).format("YYYY-MM-DD")}/uploaded/${getValue(bodyObj, `vendor_name`, "")}`
    );
  };
  let now = getValue(request, `from_date`, "");
  let next30days =
    now && new Date(now.getFullYear(), now.getMonth(), now.getDate() + 31);

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "report_analytics_fixed_report"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={false}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={false}
              handleRemoveNavItems={handleRemoveNavItems}
              delete={
                getValue(props, `permissions`, []).includes("delete")
                  ? true
                  : false
              }
              handleDeleteFun={handleDeleteFun}
            />
          )}
          {/* <div className="dashboard-wrapper__header">
            <div className=" d-flex align-items-center justify-content-between">
              <div className="d-flex">
                <NavLink
                  to="/report/fixed-reports"
                  className="user-details-wrapper__header-back-link"
                >
                  <img src="/images/back-link.svg" className="img-fluid" />
                </NavLink>
                <h4 className="dashbaord-wrapper__header-title ms-3">
                  Uploaded and Not Uploaded Status Reports
                </h4>
              </div>
            </div>
          </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                to="/report/fixed-reports"
                className="user-details-wrapper__header-back-link me-2"
              >
                <img src="/images/back-link.svg" className="img-fluid" />
              </NavLink>
              <div className="header-parent-icon-holder">
                <MoreReportSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Reports
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Uploaded and Not Uploaded Status Reports
                </h4>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <RightMenuHeaders
                route={"/report/vendor-audit/add"}
                handleAddFun={() => handleAddFun()}
                isAdd={
                  getValue(props, `permissions`, []).includes("create")
                    ? true
                    : false
                }
                add={
                  getValue(props, `permissions`, []).includes("create")
                    ? "true"
                    : "false"
                }
              />
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper`}
            id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/report/vendor-audit/add"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  smartFilter={false}
                  locationUpload={true}
                  search={"false"}
                  stop_schedule={getValue(info, `is_scheduled`, false)}
                  handleStopSchedule={handleStopSchedule}
                  scheduleLoading={scheduleLoading}
                  handleAddFun={() => handleAddFun()}
                  isAdd={
                    getValue(props, `permissions`, []).includes("create")
                      ? true
                      : false
                  }
                  add={
                    getValue(props, `permissions`, []).includes("create")
                      ? "true"
                      : "false"
                  }
                />
              </div>
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  checkboxlogo
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <ReportsNotfoundPopup
                        handleAddFun={() => handleAddFun()}
                      />
                    </>
                  ) : (
                    <>
                      <ReportsNotfoundPopup
                        handleAddFun={() => handleAddFun()}
                      />
                    </>
                  )}
                </>
              )}
            </div>
            {totalCount != 0 && (
              <div className="footer-wrapper d-flex justify-content-between">
                {list.length > 0 && (
                  <img
                    src="/images/building-illustration.svg"
                    className="img-fluid"
                  />
                )}
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <p className="show-rows-count mt-3 d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </p>
                )}
              </div>
            )}
            <DeleteModal
              isOpen={isDelete}
              handleModal={handleDelete}
              handleSubmit={handleDeleteFunction}
              deleteValue={deleteValue}
            />

            <Modal isOpen={isOpen} toggle={isOpen}>
              <section className="add-popup-wrapper">
                <div className="add-popup-wrapper__popup">
                  <div className="add-popup-wrapper__form-group form-group">
                    Uploaded and Not Uploaded Status Reports{" "}
                  </div>
                  <div className=" form-group">
                    <label htmlFor="title" className="rolls-label">
                      Report Name <span>*</span>
                    </label>
                    <InputField
                      inputType="TEXT"
                      placeholder="Enter Report Name"
                      label="Report Name"
                      className="form-control rolls-form-control"
                      id="title"
                      // validator={simpleValidator}
                      value={getValue(request, `report_name`, "")}
                      onChange={(e: any) =>
                        setRequest({
                          ...request,
                          report_name: sanitizeInput(e.target.value),
                        })
                      }
                      validator={simpleValidator}
                    />
                  </div>
                  <div className=" form-group">
                    <label htmlFor="title" className="rolls-label">
                      Report Description <span></span>
                    </label>
                    <InputField
                      inputType="TEXT"
                      placeholder="Enter Report Description"
                      label="Report Description"
                      className="form-control rolls-form-control"
                      id="title"
                      // validator={simpleValidator}
                      value={getValue(request, `report_description`, "")}
                      onChange={(e: any) =>
                        setRequest({
                          ...request,
                          report_description: sanitizeInput(e.target.value),
                        })
                      }
                      // validator={simpleValidator}
                    />
                  </div>

                  <div className=" form-group">
                    <label htmlFor="title" className="rolls-label">
                      Status On <span>*</span>
                    </label>
                    <DatePicker
                      selectsRange={true}
                      startDate={getValue(request, `from_date`, "")}
                      endDate={getValue(request, `to_date`, "")}
                      className="react-date-picker__inputGroup__input"
                      onChange={(update: any) => {
                        handleDate(update);
                      }}
                      dateFormat="d MMM yyyy"
                      showMonthDropdown
                      showYearDropdown
                      placeholderText={`Status From Date - Status To Date`}
                      dropdownMode="select"
                      minDate={getValue(request, `from_date`, "")}
                      maxDate={
                        getValue(request, `from_date`, "")
                          ? next30days
                          : new Date()
                      }
                      isClearable
                    />
                    {simpleValidator && (
                      <span className="form-error">
                        {simpleValidator.current.message(
                          "Status On",
                          getValue(request, `from_date`, "") &&
                            getValue(request, `to_date`, ""),
                          "required"
                        )}
                      </span>
                    )}
                  </div>
                  <div className=" form-group">
                    <label htmlFor="title" className="rolls-label">
                      Month <span>*</span>
                    </label>
                    <InputField
                      inputType="INPUT_REACT_SELECT"
                      placeholder="Choose Month"
                      className="form-control w-100"
                      name="month"
                      id="month"
                      options={months}
                      value={getValue(request, `month`, [])}
                      onChange={(e: any) =>
                        setRequest({
                          ...request,
                          month: e,
                        })
                      }
                      isClear
                      validator={simpleValidator}
                      label={"Month"}
                      isMulti={true}
                    />
                  </div>
                  <div className=" form-group">
                    <label htmlFor="title" className="rolls-label">
                      Year <span>*</span>
                    </label>
                    <InputField
                      inputType="INPUT_REACT_SELECT"
                      placeholder="Choose Year"
                      className="form-control w-100"
                      name="year"
                      id="year"
                      options={years}
                      value={getValue(request, `year`, [])}
                      onChange={(e: any) =>
                        setRequest({
                          ...request,
                          year: e,
                        })
                      }
                      label={"Year"}
                      isClear
                      validator={simpleValidator}
                      isMulti={true}
                    />
                  </div>
                  <div className="add-popup-wrapper__cta-wrapper">
                    <button
                      onClick={handleModal}
                      className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
                    >
                      Cancel
                    </button>
                    <button
                      className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
                      onClick={handleSubmit}
                      disabled={submitLoading}
                    >
                      {submitLoading ? "Please Wait..." : "Submit"}
                    </button>
                  </div>
                </div>
              </section>
            </Modal>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default ReportsVendorAuditUploads;
